import tinycolor from "tinycolor2";

const headTheme = document.querySelector('head meta[name="theme-color"]')
const body = document.querySelector('body')
const colorAccent = getCookie('colorAccent');

// Funktion zum Auslesen eines Cookies
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function lightenHexColor(hex, percent) {
    // Die Hex-Farbe normalisieren (falls sie mit '#' beginnt)
    hex = hex.replace(/^#/, '');
    
    // Hex-Farbe in RGB umwandeln
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Die RGB-Werte anpassen
    r = Math.min(255, Math.max(0, r + Math.round((255 - r) * percent / 100)));
    g = Math.min(255, Math.max(0, g + Math.round((255 - g) * percent / 100)));
    b = Math.min(255, Math.max(0, b + Math.round((255 - b) * percent / 100)));

    // Die neuen RGB-Werte wieder in Hex umwandeln
    r = r.toString(16).padStart(2, '0');
    g = g.toString(16).padStart(2, '0');
    b = b.toString(16).padStart(2, '0');

    // Die angepasste Hex-Farbe zurückgeben
    return `${r}${g}${b}`;
}

if (colorAccent) {
    const tinyColor = tinycolor(colorAccent);
    const isDark = tinyColor.getBrightness() < 175;
    const hexColor = tinyColor.toHex()
    body.style.setProperty('--color--accent', "#" + hexColor);

    if (!isDark) {
        body.classList.add('dark')
        headTheme.setAttribute('content', '#83786f');
        
        if (hexColor == 'ff5779') {
            body.style.setProperty('--color--accent-light', "#FF8C90");
        } else {
            const hexLightColor = lightenHexColor(hexColor, -30);
            body.style.setProperty('--color--accent-light', "#" + hexLightColor);
        }
    } else {
        body.classList.remove('dark')
        headTheme.setAttribute('content', '#f8f7f7');

        if (hexColor == 'ff5779') {
            body.style.setProperty('--color--accent-light', "#FF8C90");
        } else {
            const hexLightColor = lightenHexColor(hexColor, 30);
            body.style.setProperty('--color--accent-light', "#" + hexLightColor);
        }
    }
}